import React from 'react';
import { Table, Input, Button, Alert } from 'reactstrap';

const MODULE_LABELS = {
  dashboard: 'Dashboard',
  reports: 'Reportes',
  leads: 'Leads',
  clients: 'Clientes',
  offers: 'Ofertas',
  quotations: 'Cotizaciones',
  sales: 'Ventas',
  items: 'Bienes',
  item_storage: 'Bodegaje',
  providers: 'Mandantes',
  categories: 'Categorías',
  colors: 'Colores',
  brands: 'Marcas',
  comments: 'Comentarios',
  users: 'Usuarios',
  roles: 'Roles',
  banners: 'Banners',
  faqs: 'Preguntas Frecuentes',
  services: 'Servicios',
  blogs: 'Blog',
  settings: 'Configuración',
  asset_tags: 'Etiquetas',
};

const ACTION_LABELS = {
  view: 'Ver',
  list: 'Listar',
  create: 'Crear',
  edit: 'Editar',
  delete: 'Eliminar',
  export: 'Exportar',
  assign: 'Asignar',
};

const ALL_ACTIONS = ['view', 'list', 'create', 'edit', 'delete', 'export', 'assign'];

const PermissionMatrix = ({ registry, registryError, permissions, onChange, onRetry }) => {
  if (registryError) {
    return (
      <Alert color="danger">
        Error al cargar permisos: {registryError}.{' '}
        {onRetry && <Button color="link" size="sm" onClick={onRetry}>Reintentar</Button>}
      </Alert>
    );
  }
  if (!registry || Object.keys(registry).length === 0) {
    return <p className="text-muted">Cargando permisos...</p>;
  }

  const modules = Object.keys(registry);

  const handleToggle = (key) => {
    const updated = { ...permissions };
    if (updated[key]) {
      delete updated[key];
    } else {
      updated[key] = true;
    }
    onChange(updated);
  };

  const handleToggleModule = (module) => {
    const moduleActions = registry[module] || [];
    const allChecked = moduleActions.every((a) => permissions[`${module}.${a}`] === true);
    const updated = { ...permissions };
    moduleActions.forEach((action) => {
      const key = `${module}.${action}`;
      if (allChecked) {
        delete updated[key];
      } else {
        updated[key] = true;
      }
    });
    onChange(updated);
  };

  const selectAll = () => {
    const updated = {};
    modules.forEach((mod) => {
      (registry[mod] || []).forEach((action) => {
        updated[`${mod}.${action}`] = true;
      });
    });
    onChange(updated);
  };

  const deselectAll = () => {
    onChange({});
  };

  return (
    <div>
      <div className="d-flex justify-content-end mb-2">
        <Button color="link" size="sm" onClick={selectAll}>
          Seleccionar todo
        </Button>
        <Button color="link" size="sm" onClick={deselectAll}>
          Deseleccionar todo
        </Button>
      </div>
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <Table bordered size="sm" className="mb-0">
          <thead>
            <tr>
              <th style={{ minWidth: '140px' }}>Módulo</th>
              {ALL_ACTIONS.map((action) => (
                <th key={action} className="text-center" style={{ fontSize: '0.8rem' }}>
                  {ACTION_LABELS[action]}
                </th>
              ))}
              <th className="text-center" style={{ fontSize: '0.8rem' }}>
                Todo
              </th>
            </tr>
          </thead>
          <tbody>
            {modules.map((mod) => {
              const moduleActions = registry[mod] || [];
              const allChecked = moduleActions.every(
                (a) => permissions[`${mod}.${a}`] === true
              );
              return (
                <tr key={mod}>
                  <td style={{ fontSize: '0.85rem' }}>
                    {MODULE_LABELS[mod] || mod}
                  </td>
                  {ALL_ACTIONS.map((action) => {
                    const applicable = moduleActions.includes(action);
                    const key = `${mod}.${action}`;
                    return (
                      <td key={action} className="text-center">
                        {applicable ? (
                          <Input
                            type="checkbox"
                            checked={permissions[key] === true}
                            onChange={() => handleToggle(key)}
                            style={{ margin: 0 }}
                          />
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                    );
                  })}
                  <td className="text-center">
                    <Input
                      type="checkbox"
                      checked={allChecked}
                      onChange={() => handleToggleModule(mod)}
                      style={{ margin: 0 }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default PermissionMatrix;
